import * as actionTypes from '../actionTypes/notificationActionTypes';
import { LOGOUT } from '../actions/actionTypes';

const initialState = {
  connectionStatus: 'disconnected',
  notifications: [],
  reminders: {},
  mailUpdates: {
    newMailCount: 0,
    lastUpdate: null,
    mailList: [],
    hasNewMail: false
  }
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGOUT:
      return initialState;
      
    case actionTypes.SSE_CONNECTION_STATUS:
      return {
        ...state,
        connectionStatus: action.status
      };

    case actionTypes.RECEIVE_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.notification]
      };

    case actionTypes.CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: []
      };

    case actionTypes.UPDATE_REMINDER_DATA:
      return {
        ...state,
        reminders: {
          ...state.reminders,
          ...action.reminderData
        }
      };

    case actionTypes.REMINDER_NEW:
      const reminderKey = action.reminder.key || action.reminder.id;
      return {
        ...state,
        reminders: {
          ...state.reminders,
          [reminderKey]: action.reminder
        }
      };

    case actionTypes.REMINDER_DISMISSED:
      const { [action.reminderId]: removed, ...remainingReminders } = state.reminders;
      return {
        ...state,
        reminders: remainingReminders
      };

    case actionTypes.UPDATE_MAIL_DATA:
      return {
        ...state,
        mailUpdates: {
          ...state.mailUpdates,
          ...action.mailData,
          lastUpdate: new Date().toISOString()
        }
      };

    case actionTypes.MAIL_NEW:
      return {
        ...state,
        mailUpdates: {
          ...state.mailUpdates,
          newMailCount: state.mailUpdates.newMailCount + 1,
          mailList: [action.mail, ...state.mailUpdates.mailList],
          hasNewMail: true,
          lastUpdate: new Date().toISOString()
        }
      };

    case actionTypes.MAIL_UPDATED:
      return {
        ...state,
        mailUpdates: {
          ...state.mailUpdates,
          mailList: state.mailUpdates.mailList.map(mail =>
            mail.id === action.mail.id ? action.mail : mail
          ),
          lastUpdate: new Date().toISOString()
        }
      };

    default:
      return state;
  }
};

export default notificationReducer;


